
let loadingDom = document.createElement('img')
loadingDom.src = require('../assets/layout/loading1.gif')
loadingDom.className = 'loading-dom'
let loadTime = 0
let isLoading = false
// loadingDom.cssText = ''
const showLoading = (l, t) => {
  if (l && t) {
    loadingDom.style.left = `${l}px`
    loadingDom.style.top = `${t}px`
  }
  loadTime = +new Date()
  if (isLoading) return
  isLoading = true
  document.body.appendChild(loadingDom)
}

const hideLoading = () => {
  if (!isLoading) return
  const discount = +new Date() - loadTime
  if (discount / 1000 >= 0) {
    document.body.removeChild(loadingDom)
  } else {
    setTimeout(() => {
      document.body.removeChild(loadingDom)
    }, 1000 - discount)
  }
  isLoading = false
}

const isProduction = process.env.NODE_ENV === 'production'

module.exports = {
  showLoading,
  hideLoading,
  isProduction
}



// WEBPACK FOOTER //
// ./src/utils/utils.js